/**
 * 报告状态
 */
export enum ReportState {
  /**
   * 未发布
   */
  UnPublished = 0,

  /**
   * 已发布
   */
  Published = 1,
}
